import api from "../services/api";

export const getNews = (url: string) => {
    return api
        .get(url)
        .then((res) => res.data);
};
